import actionTypes from "./actionTypes";
import * as spravyUtils from "../utils/spravyUtils";

export const updateCustomFiltersSpravy = (customFilters) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_CUSTOM_FILTERS_SPRAVA,
      customFilters,
    });
  };
};

export const changeSprava = (sprava) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.CHANGE_SPRAVA,
      data: sprava,
    });
  };
};

const updateSpravaRequest = () => ({
  type: actionTypes.PUT_SPRAVA_REQUEST,
});
const updateSpravaSuccess = (res) => ({
  type: actionTypes.PUT_SPRAVA_SUCCESS,
  res,
});
const updateSpravaFailure = (error) => ({
  type: actionTypes.PUT_SPRAVA_FAILURE,
  error,
});
export const updateSprava = (data) => {
  return async (dispatch) => {
    try {
      dispatch(updateSpravaRequest());
      let res = await spravyUtils.updateSprava(data);
      dispatch(updateSpravaSuccess(res));
    } catch (error) {
      dispatch(updateSpravaFailure(error));
    }
  };
};

const getSpravaRequest = () => ({
  type: actionTypes.GET_SPRAVA_REQUEST,
});
const getSpravaSuccess = (res) => ({
  type: actionTypes.GET_SPRAVA_SUCCESS,
  res,
});
const getSpravaFailure = (error) => ({
  type: actionTypes.GET_SPRAVA_FAILURE,
  error,
});
export const getSprava = (id) => {
  return async (dispatch) => {
    try {
      dispatch(getSpravaRequest());
      let res = await spravyUtils.getSprava(id);
      dispatch(getSpravaSuccess(res));
    } catch (error) {
      dispatch(getSpravaFailure(error));
    }
  };
};

const getListSpravaRequest = () => ({
  type: actionTypes.GET_LIST_SPRAVA_REQUEST,
});
const getListSpravaSuccess = (
  res,
  gridFilter,
  gridSort,
  gridPage,
  customFilters
) => ({
  type: actionTypes.GET_LIST_SPRAVA_SUCCESS,
  gridFilter,
  gridSort,
  gridPage,
  customFilters,
  res,
});
const getListSpravaFailure = (error) => ({
  type: actionTypes.GET_LIST_SPRAVA_FAILURE,
  error,
});
export const getListSprava = ({
  gridFilter,
  gridSort,
  gridPage,
  customFilters,
}) => {
  return async (dispatch) => {
    try {
      dispatch(getListSpravaRequest());

      const filter = { filters: [...gridFilter.filters, ...customFilters] };
      let res = await spravyUtils.getListSprava(filter, gridSort, gridPage);

      dispatch(
        getListSpravaSuccess(res, gridFilter, gridSort, gridPage, customFilters)
      );
    } catch (error) {
      dispatch(getListSpravaFailure(error));
    }
  };
};
export const getListSpravaCurrentUser = ({
  gridFilter,
  gridSort,
  gridPage,
  customFilters,
}) => {
  return async (dispatch) => {
    try {
      dispatch(getListSpravaRequest());

      const filter = { filters: [...gridFilter.filters, ...customFilters] };
      let res = await spravyUtils.getListSpravaCurrentUser(
        filter,
        gridSort,
        gridPage
      );

      dispatch(
        getListSpravaSuccess(res, gridFilter, gridSort, gridPage, customFilters)
      );
    } catch (error) {
      dispatch(getListSpravaFailure(error));
    }
  };
};

const getCountNeprecitaneSpravyRequest = () => ({
  type: actionTypes.GET_COUNT_NEPRECITANE_SPRAVY_REQUEST,
});
const getCountNeprecitaneSpravySuccess = (res) => ({
  type: actionTypes.GET_COUNT_NEPRECITANE_SPRAVY_SUCCESS,
  res,
});
const getCountNeprecitaneSpravyFailure = (error) => ({
  type: actionTypes.GET_COUNT_NEPRECITANE_SPRAVY_FAILURE,
  error,
});
export const getCountNeprecitaneSpravy = (I_ORGAN) => {
  return async (dispatch) => {
    try {
      dispatch(getCountNeprecitaneSpravyRequest());
      let res = await spravyUtils.getCountNeprecitaneSpravy(I_ORGAN);
      dispatch(getCountNeprecitaneSpravySuccess(res));
    } catch (error) {
      dispatch(getCountNeprecitaneSpravyFailure(error));
    }
  };
};
